module.exports = __webpack_public_path__ + "static/media/step2.65a87600.svg";